import script from "./tutorOnboardingFirstPage.vue?vue&type=script&setup=true&lang=js"
export * from "./tutorOnboardingFirstPage.vue?vue&type=script&setup=true&lang=js"

import "./tutorOnboardingFirstPage.vue?vue&type=style&index=0&id=2f9ab908&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f9ab908"]])

export default __exports__